import { useState, useEffect, useContext } from 'react';
import InputMask from 'react-input-mask';
import { useNavigate , useParams, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth'; 
// import { atualizarAnalise } from '../../services/api';
import { listarCompartimentos, buscarAnalise, incluirAnalise, alterarAnalise, excluirAnalise } from '../../services/apigateway.js';


import { toast } from 'react-toastify';
import { getS3Url } from '../../services/funcoes';

import { FaCircleXmark } from 'react-icons/fa6';
import { TbPhotoSearch } from 'react-icons/tb';

import DatePicker, { registerLocale } from 'react-datepicker';
// import ptBR from 'date-fns/locale/pt-BR';
import { parse } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { dataHoraFormatoMySQL, validarData } from './../../services/datautils.js'

import Globais from '../../components/Globais/Globais'; 
import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';

import ModalSenha from '../../components/Modal/modalsenha';
import ModalImagem from '../../components/Modal/modalimagem';

import Axios from 'axios';

export default function CadastroAnalises({funcao}){
  const { clienteId, identificador, ligaMenu, perfilUsuario } = useContext(AuthContext);
  const { numero, ordemId, nomeEquipamento, equipamentoId, codigoCompartimento, datainicialOM, datafinalOM, datainclusaoOM } = useParams();
  const readOnly = (funcao === 'Exclusão');

  const history = useNavigate();

  const [loading, setLoading] = useState(false);

  const [compartimentos, setCompartimentos] = useState([]);
  const [compartimentoSelected, setCompartimentoSelected] = useState(null);
  const [compartimentoId, setCompartimentoId] = useState('');
  
  const [tipo, setTipo] = useState(null);
  const [dataInclusao, setDataInclusao] = useState('');
  const [datahorainicial, setDataHoraInicial] = useState('');
  const [resinianalise, setResIniAnalise] = useState('');
  const [resnasinicial, setResNasInicial] = useState('');
  const [idtcreinicial, setIdtCreInicial] = useState('');
  const [idtfotoinicial, setIdtFotoInicial] = useState('');
  const [fotoinicial, setFotoInicial] = useState('');
  const [datahorafinal, setDataHoraFinal] = useState('');
  const [resfimanalise, setResFimAnalise] = useState('');
  const [resnasfinal, setResNasFinal] = useState('');
  const [idtcrefinal, setIdtCreFinal] = useState('');
  const [idtfotofinal, setIdtFotoFinal] = useState('');
  const [fotofinal, setFotoFinal] = useState('');
  const [idtfotobujao, setIdtFotoBujao] = useState('');
  const [fotobujao, setFotoBujao] = useState('');
  const [idtfotofiltro, setIdtFotofiltro] = useState('');
  const [fotofiltro, setFotoFiltro] = useState('');
  const [observacao, setObservacao] = useState('');
  const [situacao, setSituacao] = useState('F');

  // Constantes de controle de Fotos
  const [operacaoFotoInicial, setOperacaoFotoInicial] = useState('Consulta');
  const [operacaoFotoFinal, setOperacaoFotoFinal] = useState('Consulta');
  const [operacaoFotoBujao, setOperacaoFotoBujao] = useState('Consulta');
  const [operacaoFotoFiltro, setOperacaoFotoFiltro] = useState('Consulta');

  const [mostrarModalSenha, setMostrarModalSenha] = useState(false);

  const [mostrarModalMembranaInicial, setMostrarModalMembranaInicial] = useState(false);
  const [mostrarModalMembranaFinal, setMostrarModalMembranaFinal] = useState(false);
  const [mostrarModalFotoBujao, setMostrarModalFotoBujao] = useState(false);
  const [mostrarModalFotoFiltro, setMostrarModalFotoFiltro] = useState(false);

  const [previewInicial, setPreviewInicial] = useState(null);
  const [previewFinal, setPreviewFinal] = useState(null);
  const [previewBujao, setPreviewBujao] = useState(null);
  const [previewFiltro, setPreviewFiltro] = useState(null);

  const [dateAuxInclusao, setDateAuxInclusao] = useState(new Date());
  const [dateAuxInicial, setDateAuxInicial] = useState(null);
  const [dateAuxFinal, setDateAuxFinal] = useState(null);

  useEffect(()=>{
    if (funcao !== 'Inclusão' && perfilUsuario === 'US') {
      //Solicita Senha
      setMostrarModalSenha(true);
    }

    if (funcao === 'Inclusão') {
      loadCompartimentos();

    } else {
      console.log('Código do Compartimento: ', codigoCompartimento);

      setCompartimentoId(codigoCompartimento);
      loadAnalise(codigoCompartimento);
    }

    // console.log('Função em cadastroanalises.js: ', funcao);
    // console.log('Datas OM: ', datainicialOM, datafinalOM);

    if (datainicialOM === null) {
      toast.error('Dados da Ordem de Manutenção inválidos. Selecione novamente');
      history(`/ordens/consulta/${ordemId}`);
    }

  }, [funcao]);

  async function loadCompartimentos(){
    setLoading(true);
    
    try {
      const result = await listarCompartimentos(clienteId, equipamentoId);

      setCompartimentos(result);

    } catch (err) {
      toast.error('Erro ao buscar compartimentos');

    } finally {
      setLoading(false);
    }  
  }

  async function loadAnalise(compartimentoId){
    setLoading(true);
    
    try {
      const result = await buscarAnalise(clienteId, ordemId, equipamentoId, codigoCompartimento);
      preencheSelecionado(result[0]);
      
    } catch (err) {
      toast.error('Erro ao buscar análise 2', err);

    } finally {
      setLoading(false);
    }  
  }

  function preencheSelecionado(analise) {
    console.log('Response: ', analise);

    setTipo(analise.tip_compartimento);
    setDataInclusao(analise.dat_horinclusao);
    setDataHoraInicial(analise.dat_horinicial);
    setResIniAnalise(analise.res_inianalise);
    setResNasInicial(analise.res_nasinicial);
    setIdtCreInicial(analise.idt_creinicial);
    setIdtFotoInicial(analise.idt_fotinicial);
    
    setDataHoraFinal(analise.dat_horfinal);
    setResFimAnalise(analise.res_fimanalise);
    setResNasFinal(analise.res_nasfinal);
    setIdtCreFinal(analise.idt_crefinal);
    setIdtFotoFinal(analise.idt_fotfinal);

    setIdtFotoBujao(analise.idt_fotbujao);
    setIdtFotofiltro(analise.idt_fotfiltro);

    setObservacao(analise.obs_analise);
    setSituacao(analise.sit_analise);

    if (funcao = 'Alteração') {
      let dataConvertida = parse(analise.dat_horinclusao, 'dd/MM/yyyy HH:mm', new Date());
      console.log('Data Inclusão Convertida: ', dataConvertida);
      setDateAuxInclusao(dataConvertida);

      if (analise.dat_horinicial !== '') {
        dataConvertida = parse(analise.dat_horinicial, 'dd/MM/yyyy HH:mm', new Date());
        console.log('Data Inicial Convertida: ', dataConvertida);
        setDateAuxInicial(dataConvertida);
      }

      if (analise.dat_horfinal !== '') {
        dataConvertida = parse(analise.dat_horfinal, 'dd/MM/yyyy HH:mm', new Date());
        console.log('Data Final Convertida: ', dataConvertida);
        setDateAuxFinal(dataConvertida);
      }

      console.log('Fotos: ', analise.idt_fotinicial, analise.idt_fotfinal, analise.idt_fotbujao, analise.idt_fotfiltro);

      // O parâmetro Date.now() é para forçar buscar a imagem novamente
      if (analise.idt_fotinicial !== '') { setPreviewInicial(getS3Url(analise.idt_fotinicial) + `?t=${Date.now()}`); }
      if (analise.idt_fotfinal !== '') { setPreviewFinal(getS3Url(analise.idt_fotfinal) + `?t=${Date.now()}`); }
      if (analise.idt_fotbujao !== '') { setPreviewBujao(getS3Url(analise.idt_fotbujao) + `?t=${Date.now()}`); }
      if (analise.idt_fotfiltro !== '') { setPreviewFiltro(getS3Url(analise.idt_fotfiltro) + `?t=${Date.now()}`); }
    }
  }

  function autorizado() { setMostrarModalSenha(false) }

  function naoAutorizado() {
    setMostrarModalSenha(false);
    history(`/ordens/consulta/${ordemId}`);
  }

  function handleChangeCompartimento(valor){
    if (valor) { 
      setCompartimentoSelected(valor);
      setCompartimentoId(compartimentos[valor].cod_compartimento);

      console.log('CompartimentoId: ', compartimentos[valor].cod_compartimento)
    }
  } 

  function consisteCampos () {
    console.log('Data Inicial: ', dateAuxInicial);
    console.log('Data Final: ', dateAuxFinal);

    if (datainicialOM === null || datainicialOM === undefined || datainicialOM === '') {
      toast.error('Dados da Ordem de Manutenção inválidos. Selecione novamente');
      history(`/ordens/consulta/${ordemId}`);
    }

    if (datafinalOM === null || datafinalOM === undefined || datafinalOM === '') {
      toast.error('Dados da Ordem de Manutenção inválidos. Selecione novamente');
      history(`/ordens/consulta/${ordemId}`);
    }

    if (resinianalise !== '') {
      if (resnasinicial === '') {
        toast.error('Resultado NAS inicial não informado');
        return false;
      }

      if(!dateAuxInicial) {
        toast.error('Data e hora iniciais não informadas');
        return false;
      }

      if (dateAuxInicial === null || dateAuxInicial === undefined || dateAuxInicial === '') {
        toast.error('Data e hora iniciais não informadas');
        return false;
      }

      if (!validarData(dataHoraFormatoMySQL(dateAuxInicial))){
        toast.error('Data e hora iniciais inválidas');
        return false;
      }

      } else {
      if (resfimanalise !== '') {
        toast.error('Resultado final informado sem resultado inicial');
        return false;
      }
      if (resnasfinal !== '') {
        toast.error('Resultado NAS final informado sem resultado inicial');
        return false;
      }

      if (dateAuxFinal) {
        if (dateAuxFinal !== '') {
          toast.error('Data e Hora final informadas sem resultado inicial');
          return false;
        } 
      }

      toast.error('Resultado inicial não informado');
      return false;
    }

    if (resfimanalise !== '') {
      if (resnasfinal === '') {
        toast.error('Resultado NAS final não informado');
        return false;
      }

      if (dateAuxFinal === null || dateAuxFinal === undefined || dateAuxFinal === '') {
        toast.error('Data e hora finais não informadas');
        return false;
      }

      if (!validarData(dataHoraFormatoMySQL(dateAuxFinal))){
        toast.error('Data e hora finais inválidas');
        return false;
      }
    }
    return true;
  }

  async function executaAcao(e){
    e.preventDefault();

    if (funcao === 'Inclusão' || funcao === 'Alteração') {
      // Consistir informações
      if (compartimentoId === '') {
        toast.error('Selecione um compartimento');
        return;
      }
      
      if (!consisteCampos()) return;
    }

    if (funcao === 'Inclusão') {
      //INSERT
      const analise = {
        clienteId: clienteId, 
        ordemId: ordemId,
        equipamentoId: equipamentoId,
        compartimentoId: compartimentoId,

        datainclusao: dataHoraFormatoMySQL(dateAuxInclusao), 

        datahorainicial: ((dateAuxInicial) ? (dataHoraFormatoMySQL(dateAuxInicial)) : ('')),
        resinianalise: resinianalise,
        resnasinicial: resnasinicial,
        idtcreinicial: idtcreinicial,
        fotoinicial: fotoinicial,

        datahorafinal: ((dateAuxFinal) ? (dataHoraFormatoMySQL(dateAuxFinal)) : ('')),
        resfimanalise: resfimanalise,
        resnasfinal: resnasfinal, 
        idtcrefinal: idtcrefinal,
        fotofinal: fotofinal,

        fotobujao: fotobujao,
        fotofiltro: fotofiltro,

        observacao: observacao,
        situacao: situacao,

        datainicialOM: datainicialOM,
        datafinalOM: datafinalOM
      }

      console.log('Análise: ', analise);

      try {
        const response = await incluirAnalise(analise);
      
        if (response.codigo === '000') {
          toast.success(response.mensagem);
          history(`/ordens/consulta/${ordemId}`);
        
        } else {
          toast.error(`Erro ao incluir análise do compartimento: ${response.mensagem}`);
        }
      } catch (err) {
        toast.error('Erro ao buscar compartimento');

      } finally {
        setLoading(false);
      }  
    }

    if (funcao === 'Alteração') {
      let datainicial = '';
      let datafinal = '';

      try {
        if (dateAuxInicial) {
          datainicial = dataHoraFormatoMySQL(dateAuxInicial);
        }

        if (dateAuxFinal) {
          datafinal = dataHoraFormatoMySQL(dateAuxFinal);
        }

        console.log('Datas: ', datainicial, datafinal);
        console.log('Idts Fotos em Alteração: ', idtfotoinicial, idtfotofinal, idtfotobujao, idtfotofiltro);

        const response = await alterarAnalise({
          clienteId: clienteId, 
          ordemId: ordemId,
          equipamentoId: equipamentoId,
          compartimentoId: compartimentoId, 

          datahorainicial: ((datainicial) ? (datainicial) : ('')),
          resinianalise: resinianalise,
          resnasinicial: resnasinicial,
          idtcreinicial: idtcreinicial,
          idtfotoinicial: idtfotoinicial,
          fotoinicial: fotoinicial,
          operacaoFotoInicial: operacaoFotoInicial,
          
          datahorafinal: ((datafinal) ? (datafinal) : ('')),
          resfimanalise: resfimanalise,
          resnasfinal: resnasfinal, 
          idtcrefinal: idtcrefinal,
          idtfotofinal: idtfotofinal,
          fotofinal: fotofinal,
          operacaoFotoFinal: operacaoFotoFinal,

          idtfotobujao: idtfotobujao,
          fotobujao: fotobujao,
          operacaoFotoBujao: operacaoFotoBujao,

          idtfotofiltro: idtfotofiltro,
          fotofiltro: fotofiltro,
          operacaoFotoFiltro: operacaoFotoFiltro,

          observacao: observacao,
          situacao: situacao,

          datainicialOM: datainicialOM,
          datafinalOM: datafinalOM
        });
      
        if (response.codigo === '000') {
          toast.success(response.mensagem);
          history(`/ordens/consulta/${ordemId}`);
        
        } else {
          toast.error(`Erro ao atualizar compartimento: ${response.mensagem}`);
        }

      } catch (err) {
        toast.error('Erro ao atualizar compartimento');

      } finally {
        setLoading(false);
      }  
    }

    if (funcao === 'Exclusão') {
      //DELETE
      try {
        console.log('Parâmetros Exclusão 1: ', clienteId, ordemId, equipamentoId, compartimentoId,
          idtfotoinicial, idtfotofinal);

        console.log('Parâmetros Exclusão 2: ', idtfotobujao, idtfotofiltro);

        // const response = await excluirAnalise(clienteId, ordemId, equipamentoId, compartimentoId,
        //   idtfotoinicial, idtfotofinal, idtfotobujao, idtfotofiltro, datainicialOM, datafinalOM, datainclusaoOM);
      
        const response = await excluirAnalise({
          clienteId: clienteId,
          ordemId: ordemId,
          equipamentoId: equipamentoId,
          compartimentoId: compartimentoId,
          idtfotoinicial: idtfotoinicial,
          idtfotofinal: idtfotofinal,
          idtfotobujao: idtfotobujao,
          idtfotofiltro: idtfotofiltro,
          datainicialOM: datainicialOM,
          datafinalOM: datafinalOM,
          datainclusaoOM: datainclusaoOM});

          // clienteId, ordemId, equipamentoId, compartimentoId,
          // idtfotoinicial, idtfotofinal, idtfotobujao, idtfotofiltro, 
          // datainicialOM, datafinalOM, datainclusaoOM});

          if (response.codigo === '000') {
          toast.success('Análise excluída com sucesso!!');
          history(`/ordens/consulta/${ordemId}`);
        
        } else {
          let mensagem = '';

          if (response.retorno === 'ER_ROW_IS_REFERENCED_2') {
            mensagem = 'Análise não pode ser excluída. Existem informações referentes!'

          } else {
            mensagem = `Erro ao excluir análise: ${response.mensagem}`
          }
          toast.error(mensagem);
        }
      } catch (err) {
        toast.error('Erro ao excluir análise');

      } finally {
        setLoading(false);
      }  
    }

    return;
  }

  function selecionarImagem(tipo, file) {
    if (tipo === 'Inicial') {
      setFotoInicial(file);
      setPreviewInicial(URL.createObjectURL(file));
      ((idtfotoinicial === '') ? setOperacaoFotoInicial('Inclusão') : (setOperacaoFotoInicial('Alteração')));
    }

    if (tipo === 'Final') {
      setFotoFinal(file);
      setPreviewFinal(URL.createObjectURL(file));
      ((idtfotofinal === '') ? setOperacaoFotoFinal('Inclusão') : (setOperacaoFotoFinal('Alteração')));
    }

    if (tipo === 'Bujão') {
      setFotoBujao(file);
      setPreviewBujao(URL.createObjectURL(file));
      ((idtfotobujao === '') ? setOperacaoFotoBujao('Inclusão') : (setOperacaoFotoBujao('Alteração')));
    }

    if (tipo === 'Filtro') {
      setFotoFiltro(file);
      setPreviewFiltro(URL.createObjectURL(file));
      ((idtfotofiltro === '') ? setOperacaoFotoFiltro('Inclusão') : (setOperacaoFotoFiltro('Alteração')));
    }
  }

  function limpaArquivo(tipo) {
    if (tipo === 'Inicial') {
      setFotoInicial('');
      setPreviewInicial(null);
      ((idtfotoinicial === '') ? setOperacaoFotoInicial('Consulta') : (setOperacaoFotoInicial('Exclusão')));
    }

    if (tipo === 'Final') {
      setFotoFinal('');
      setPreviewFinal(null);
      ((idtfotofinal === '') ? setOperacaoFotoFinal('Consulta') : (setOperacaoFotoFinal('Exclusão')));
    }

    if (tipo === 'Bujão') {
      setFotoBujao('');
      setPreviewBujao(null);
      ((idtfotobujao === '') ? setOperacaoFotoBujao('Consulta') : (setOperacaoFotoBujao('Exclusão')));
    }

    if (tipo === 'Filtro') {
      setFotoFiltro('');
      setPreviewFiltro(null);
      ((idtfotofiltro === '') ? setOperacaoFotoFiltro('Consulta') : (setOperacaoFotoFiltro('Exclusão')));
    }
  }

  function handleSair(e){
    history(`/ordens/consulta/${ordemId}`);
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Análises'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Analise...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }

  if (mostrarModalSenha) {
    return(
      <>
        {<ModalSenha identificador={identificador} onConfirmar={() => autorizado()} onCancelar={() => naoAutorizado()} />}
      </>
    )
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Cadastro de Analises ' + ' - ' + `${funcao}`} destination={''} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <section className='p-4 h-full'>

            <h3 className='font-semibold text-lg mb-3 mt-1'>Ordem de Manutenção: {numero}</h3>
            <h3 className='font-semibold text-lg mb-3 mt-1'>Equipamento: {nomeEquipamento}</h3>
            <div>
              {(funcao === 'Inclusão') ? (
                <div className="single-input">
                  <span>
                    <label className="combo-label"> Compartimento:  </label>
                    <select className="combo-select" value={compartimentoSelected} onChange={e => handleChangeCompartimento(e.target.value)} >
                      <option key='0' value=''>Selecione um Compartimento</option>
                      {compartimentos.map((item, index) => {
                        return(
                          <option key={item.cod_compartimento} value={index}>
                            {item.tip_compartimento} 
                          </option>
                        )
                      })}
                    </select>
                  </span>
                </div>
              ):(
                <div>
                  <div className="input-group md:mb-3">
                    <label for="c">Compartimento</label>
                    <input 
                      type="text" 
                      id='tipo' 
                      name='tipo' 
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      value={tipo}
                      onChange={(e) => setCompartimentoSelected(e.target.value)}
                      readOnly={readOnly}
                    />
                  </div>
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-gray-100 p-4 rounded shadow">
                  <h3 className="text-lg font-semibold text-blue-700 mb-3">Análise Inicial</h3>

                  <div className="space-y-2">
                    <div className="input-group md:mb-3">
                      <label>Classificação ISO 4406:</label>
                      <InputMask
                        mask="99/99/99"
                        value={resinianalise}
                        onChange={(e) => setResIniAnalise(e.target.value)}
                        readOnly={readOnly}
                      >
                        {(inputProps) => (
                          <input
                            {...inputProps}
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-300"
                            placeholder="00/00/00"
                          />
                        )}
                      </InputMask>
                    </div>
                    <div className="input-group md:mb-3">
                      <label>Classificação NAS 1638:</label>
                      <input 
                        type="text" 
                        maxLength="2"
                        id='resnasinicial' 
                        name='resnasinicial' 
                        className='w-full p-2 border border-gray-300 rounded-md' 
                        value={resnasinicial}
                        onChange={(e) => setResNasInicial(e.target.value)}
                        readOnly={readOnly}
                      />
                    </div>
                    <div className="input-group md:mb-3">
                      <label>Data/Hora Inicial:</label>
                      {(funcao === 'Inclusão' || funcao === 'Alteração') ? (
                        <div>
                          <DatePicker
                            selected={dateAuxInicial}
                            onChange={(date) => setDateAuxInicial(date)}
                            dateFormat="dd/MM/yyyy HH:mm"
                            locale="pt-BR"
                            placeholderText="Selecione"
                            className="w-full p-2 border border-gray-300 rounded-md"
                            isClearable
                            showTimeSelect
                            timeIntervals={1}
                          />
                        </div>
                      ) : (
                        <div>
                          <input 
                            type="text" 
                            id='dathorinicial' 
                            name='dathorinicial' 
                            placeholder={'Data Inicial'}
                            className='w-full p-2 border border-gray-300 rounded-md' 
                            autocomplete='dathorinicial' 
                            value={datahorainicial} 
                            onChange={(e) => setDataHoraInicial(e.target.value)}
                            readOnly={readOnly}
                          />
                        </div>                    
                      )}
                    </div>
                    <div className="input-group mb-3">
                      <label>Crepitação</label>
                      <span>
                        <div className='flex items-center gap-2'>
                          <div className="single-input flex items-center">
                            <input 
                              type="radio" 
                              id='ausente' 
                              name='ausente' 
                              value='A' 
                              onChange={(e) => setIdtCreInicial(e.target.value)} 
                              checked={idtcreinicial === 'A'}
                              disabled={readOnly}
                            /> 
                            <label for="ativo" className='mb-0'>Ausente</label>
                          </div>
                          <div className="single-input flex items-center">
                            <input 
                              type="radio" 
                              id='presente' 
                              name='presente' 
                              value='P' 
                              onChange={(e) => setIdtCreInicial(e.target.value)} 
                              checked={idtcreinicial === 'P'}
                              disabled={readOnly}
                            /> 
                            <label for="inativo">Presente</label>
                          </div>
                          <div className="single-input flex items-center">
                            <input 
                              type="radio" 
                              id='naoaplica' 
                              name='naoaplica' 
                              value='N' 
                              onChange={(e) => setIdtCreInicial(e.target.value)} 
                              checked={idtcreinicial === 'N'}
                              disabled={readOnly}
                            /> 
                            <label for="inativo">Não se aplica</label>
                          </div>
                        </div>
                      </span>
                    </div>

                    <div className="grid grid-rows-2">
                      <div className="flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700">Membrana Inicial</label>
                        {(funcao === 'Inclusão' || funcao === 'Alteração') && (
                            <button type='button' className="text-blue-600 text-lg md-4" onClick={() => setMostrarModalMembranaInicial(true)}>
                              <TbPhotoSearch size={16} /> 
                            </button>
                        )}

                        {(funcao === 'Alteração' && (fotoinicial || previewInicial)) && (
                            <button type='button'onClick={() => limpaArquivo('Inicial')}>
                              <FaCircleXmark color='blue' size={16} />
                            </button>
                        )}
                      </div>

                      <div>
                        {(funcao === 'Inclusão' && fotoinicial) && (
                          <img src={previewInicial} alt="Inicial" style={{ maxWidth: '60%', marginTop: 10 }} />
                        )}

                        {(funcao !== 'Inclusão' && previewInicial) && (
                          <img src={previewInicial} alt="Inicial" style={{ maxWidth: '60%', marginTop: 10 }} />
                        )}

                        <ModalImagem
                          isOpen={mostrarModalMembranaInicial}
                          onClose={() => setMostrarModalMembranaInicial(false)}
                          onSelecionar={(file) => selecionarImagem('Inicial',file)}
                          titulo='Membrana Inicial'
                        />
                      </div>
                    </div>

                  </div>
                </div>

                <div className="bg-gray-100 p-4 rounded shadow">
                  <h3 className="text-lg font-semibold text-green-700 mb-3">Análise Final</h3>
                  <div className="space-y-2">
                    <div className="input-group md:mb-3">
                      <label for="c">Classificação ISO 4406:</label>
                      <InputMask
                        mask="99/99/99"
                        value={resfimanalise}
                        onChange={(e) => setResFimAnalise(e.target.value)}
                        readOnly={readOnly}
                      >
                        {(inputProps) => (
                          <input
                            {...inputProps}
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-300"
                            placeholder="00/00/00"
                          />
                        )}
                      </InputMask>
                    </div>
                    <div className="input-group md:mb-3">
                      <label for="c">Classificação NAS 1638:</label>
                      <input 
                        type="text" 
                        maxLength="2"
                        id='resnasfinal' 
                        name='resnasfinal' 
                        className='w-full p-2 border border-gray-300 rounded-md' 
                        value={resnasfinal}
                        onChange={(e) => setResNasFinal(e.target.value)}
                        readOnly={readOnly}
                      />
                    </div>
                    <div className="input-group md:mb-3">
                      <label>Data/Hora Final:</label>
                      {(funcao === 'Inclusão' || funcao === 'Alteração') ? (
                        <div>
                          <DatePicker
                            selected={dateAuxFinal}
                            onChange={(date) => setDateAuxFinal(date)}
                            dateFormat="dd/MM/yyyy HH:mm"
                            locale="pt-BR"
                            placeholderText="Selecione"
                            className="w-full p-2 border border-gray-300 rounded-md"
                            isClearable
                            showTimeSelect
                            timeIntervals={1}
                          />
                        </div>
                      ) : (
                        <div>
                          <input 
                            type="text" 
                            id='dathorfinal' 
                            name='dathorfinal' 
                            placeholder={'Data Final'}
                            className='w-full p-2 border border-gray-300 rounded-md' 
                            autocomplete='dathorfinal' 
                            value={datahorafinal} 
                            onChange={(e) => setDataHoraFinal(e.target.value)}
                            readOnly={readOnly}
                          />
                        </div>                    
                      )}
                    </div>
                    <div className="input-group mb-3">
                      <label>Crepitação</label>
                      <span>
                        <div className='flex items-center gap-2'>
                          <div className="single-input flex items-center">
                            <input 
                              type="radio" 
                              id='ausentefinal' 
                              name='ausentefinal' 
                              value='A' 
                              onChange={(e) => setIdtCreFinal(e.target.value)} 
                              checked={idtcrefinal === 'A'}
                              disabled={readOnly}
                            /> 
                            <label for="ativo" className='mb-0'>Ausente</label>
                          </div>
                          <div className="single-input flex items-center">
                            <input 
                              type="radio" 
                              id='presentefinal' 
                              name='presentefinal' 
                              value='P' 
                              onChange={(e) => setIdtCreFinal(e.target.value)} 
                              checked={idtcrefinal === 'P'}
                              disabled={readOnly}
                            /> 
                            <label for="inativo">Presente</label>
                          </div>
                          <div className="single-input flex items-center">
                            <input 
                              type="radio" 
                              id='naoaplicafinal' 
                              name='naoaplicafinal' 
                              value='N' 
                              onChange={(e) => setIdtCreFinal(e.target.value)} 
                              checked={idtcrefinal === 'N'}
                              disabled={readOnly}
                            /> 
                            <label for="inativo">Não se aplica</label>
                          </div>
                        </div>
                      </span>
                    </div>

                    <div className="grid grid-rows-2">
                      <div className="flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700">Membrana Final</label>
                        {(funcao === 'Inclusão' || funcao === 'Alteração') && (
                            <button type='button' className="text-blue-600 text-lg md-4" onClick={() => setMostrarModalMembranaFinal(true)}>
                              <TbPhotoSearch size={16} /> 
                            </button>
                        )}

                        {(funcao === 'Alteração' && (fotofinal || previewFinal)) && (
                            <button type='button'onClick={() => limpaArquivo('Final')}>
                              <FaCircleXmark color='blue' size={16} />
                            </button>
                        )}
                      </div>

                      <div>
                        {(funcao === 'Inclusão' && fotofinal) && (
                          <img src={previewFinal} alt="Desvio" style={{ maxWidth: '60%', marginTop: 10 }} />
                        )}

                        {(funcao !== 'Inclusão' && previewFinal) && (
                          <img src={previewFinal} alt="Desvio" style={{ maxWidth: '60%', marginTop: 10 }} />
                        )}

                        <ModalImagem
                          isOpen={mostrarModalMembranaFinal}
                          onClose={() => setMostrarModalMembranaFinal(false)}
                          onSelecionar={(file) => selecionarImagem('Final',file)}
                          titulo='Membrana Final'
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Imagens */}
              <div className="bg-gray-100 p-4 rounded shadow">
                <div className="border-t border-secondary">
                  <h3 className="text-xl font-semibold text-gray-700">Imagens</h3>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-100">
                {/* Coluna da Imagem 1 */}
                <div className="bg-gray-100 p-4 rounded shadow">
                  <div className="grid grid-rows-2">
                    <div className="flex items-center gap-2">
                      <label className="text-sm font-medium text-gray-700">Imagem 1</label>
                      {(funcao === 'Inclusão' || funcao === 'Alteração') && (
                          <button type='button' className="text-blue-600 text-lg md-4" onClick={() => setMostrarModalFotoBujao(true)}>
                            <TbPhotoSearch size={16} /> 
                          </button>
                      )}

                      {(funcao === 'Alteração' && (fotobujao || previewBujao)) && (
                          <button type='button'onClick={() => limpaArquivo('Bujão')}>
                            <FaCircleXmark color='blue' size={16} />
                          </button>
                      )}
                    </div>

                    <div>
                      {(funcao === 'Inclusão' && fotobujao) && (
                        <img src={previewBujao} alt="Imagem" style={{ maxWidth: '60%', marginTop: 10 }} />
                      )}

                      {(funcao !== 'Inclusão' && previewBujao) && (
                        <img src={previewBujao} alt="Imagem" style={{ maxWidth: '60%', marginTop: 10 }} />
                      )}

                      <ModalImagem
                        isOpen={mostrarModalFotoBujao}
                        onClose={() => setMostrarModalFotoBujao(false)}
                        onSelecionar={(file) => selecionarImagem('Bujão',file)}
                        titulo='Imagem 1'
                      />
                    </div>

                  </div>

                </div>

                {/* Coluna da Imagem 2 */}
                <div className="bg-gray-100 p-4 rounded shadow">
                  <div className="grid grid-rows-2">
                    <div className="flex items-center gap-2">
                      <label className="text-sm font-medium text-gray-700">Imagem 2</label>
                      {(funcao === 'Inclusão' || funcao === 'Alteração') && (
                          <button type='button' className="text-blue-600 text-lg md-4" onClick={() => setMostrarModalFotoFiltro(true)}>
                            <TbPhotoSearch size={16} /> 
                          </button>
                      )}

                      {(funcao === 'Alteração' && (fotofiltro || previewFiltro)) && (
                          <button type='button'onClick={() => limpaArquivo('Filtro')}>
                            <FaCircleXmark color='blue' size={16} />
                          </button>
                      )}
                    </div>

                    <div>
                      {(funcao === 'Inclusão' && fotofiltro) && (
                        <img src={previewFiltro} alt="Desvio" style={{ maxWidth: '60%', marginTop: 10 }} />
                      )}

                      {(funcao !== 'Inclusão' && previewFiltro) && (
                        <img src={previewFiltro} alt="Desvio" style={{ maxWidth: '60%', marginTop: 10 }} />
                      )}

                      <ModalImagem
                        isOpen={mostrarModalFotoFiltro}
                        onClose={() => setMostrarModalFotoFiltro(false)}
                        onSelecionar={(file) => selecionarImagem('Filtro',file)}
                        titulo='Imagem 2'
                      />
                    </div>
                    
                  </div>

                </div>
              </div>

            </div>

            <Footer funcao={funcao} executa={executaAcao} sair={handleSair} />
          </section>
        </section>

      </main>

      <Rodape versao={Globais.versao}/>
    </div>
  )
}
